// src/components/UnidadeOrganica/UnidadeOrganicaForm.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { criarUnidadeOrganica } from '../../services/unidadeOrganicaService';

/**
 * Formulário para criação de Unidade Orgânica.
 * @param {Object} props
 * @param {Function} props.onSuccess Callback executado após criação bem-sucedida.
 */
const UnidadeOrganicaForm = ({ onSuccess }) => {
  const [nome, setNome] = useState('');
  const [tipo, setTipo] = useState('DIRECAO_ACADEMICA');
  const [dataInicio, setDataInicio] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const payload = {
        nome: nome.trim(),
        tipo,
        data_inicio: dataInicio // formato YYYY-MM-DD
      };

      await criarUnidadeOrganica(payload);
      onSuccess();
      // limpar campos
      setNome('');
      setTipo('DIRECAO_ACADEMICA');
      setDataInicio('');
    } catch (err) {
      console.error('Erro ao criar unidade orgânica:', err);
      setError('Falha ao criar unidade orgânica. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          Nome:
          <input
            type="text"
            placeholder="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      <div>
        <label>
          Tipo:
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            disabled={loading}
          >
            <option value="DIRECAO_ACADEMICA">Direção Acadêmica</option>
            <option value="DIRECAO_CIENTIFICA">Direção Científica</option>
          </select>
        </label>
      </div>
      <div>
        <label>
          Data de Início:
          <input
            type="date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" disabled={loading}>
        {loading ? 'Criando...' : 'Criar Unidade Orgânica'}
      </button>
    </form>
  );
};

UnidadeOrganicaForm.propTypes = {
  onSuccess: PropTypes.func.isRequired
};

export default UnidadeOrganicaForm;
